<template>
  <div>
    <!-- Name Cell -->
    <div v-if="type === 'name'">
      <div
          v-if="boldHeader"
          class="body__normal-medium">
        {{ boldHeader }}
      </div>
      <div
          v-if="personName"
          class="body__small-regular__secondary personName__container body">
        <img
            :src="personIcon"
            class="personName__icon">
        {{ personName }}
      </div>
    </div>

    <!-- Frequency Cell -->
    <div v-if="type === 'frequency'">
      <div
          v-if="frequencyRange"
          class="body__normal-regular">
        {{ frequencyRange }}
      </div>
      <div
          v-if="allowedDays"
          class="body__small-regular__secondary body">
        {{ allowedDays }}
      </div>
    </div>

    <!-- Access Period Cell -->
    <div v-if="type === 'accessPeriod'">
      <div
          v-if="accessPeriodRange"
          class="body__normal-regular">
        {{ accessPeriodRange }}
      </div>

      <div
          v-if="expiredOn"
          class="body__small-medium__secondary body red">
        <span class="body__small-medium__secondary red">Expired on: </span>{{ expiredOn }}
      </div>
      <div
          v-else-if="deletedOn"
          class="body__small-medium__secondary body red">
        <span class="body__small-medium__secondary red">Deleted on: </span>{{ deletedOn }}
      </div>
      <div
          v-else-if="createdOn"
          class="body__small-medium__secondary body">
        <span class="body__small-medium__secondary">Created on: </span>{{ createdOn }}
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty, get } from "lodash";

export default {
  name: "SchedulesTableCell",
  props: {
    cellData: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      icons: {
        active: require("@/assets/icons/new-ui/customer/devices/schedules/personIcon.svg"),
        inactive: require("@/assets/icons/new-ui/customer/devices/schedules/personIcon-inactive.svg"),
      },
      frequencyRange: undefined,
      accessPeriodRange: undefined,
      boldHeader: undefined,
      createdOn: undefined,
      expiredOn: undefined,
      deletedOn: undefined,
      personName: undefined,
      frequencyDays: undefined,
      isActive: true,
    };
  },
  computed: {
    personIcon() {
      if (this.isActive) {
        return this.icons.active;
      }

      return this.icons.inactive;
    },
    allowedDays() {
      if (isEmpty(this.frequencyDays)) {
        return undefined;
      }

      return this.frequencyDays.join(", ");
    },
  },
  created() {
    this.frequencyRange = get(this.cellData, "frequency.range", undefined);
    this.boldHeader = get(this.cellData, "name.business", undefined);
    this.createdOn = get(this.cellData, "accessPeriod.creationDate", undefined);
    this.expiredOn = get(this.cellData, "accessPeriod.expiredOn", undefined);
    this.deletedOn = get(this.cellData, "accessPeriod.deletedOn", undefined);
    this.personName = get(this.cellData, "name.person", undefined);
    this.frequencyDays = get(this.cellData, "frequency.days", undefined);
    this.accessPeriodRange = get(
      this.cellData,
      "accessPeriod.range",
      undefined
    );

    if (isEmpty(this.expiredOn) && isEmpty(this.deletedOn)) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
  },
};
</script>

<style scoped>
.body {
  margin-top: 2px;
}

.personName__icon {
  margin-right: 5px;
  width: 14px;
  height: 14px;
}
.personName__container {
  align-items: center;
  display: flex;
}

.red {
  color: #d4231a;
}
</style>
